import { UserRound } from "lucide-react"
import TrBtn from "./TrBtn"

const ViewUserButton = ({ action }) => {
  return (
    <TrBtn
      text="View"
      action={action}
    >
      <UserRound size={15} />
    </TrBtn>
  )
}

export default ViewUserButton